import React from "react";

const Status = () => {
  return <div>{JSON.stringify({ status: "ok" })}</div>;
};

export default Status;
